import React, {useState, useEffect, useRef} from 'react';
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

import MAYOCLINIC from '../../images/homepage/mayoClinic.png';
import KAISER from '../../images/homepage/kaiserPermanente.png';
import NYUHEALTH from '../../images/homepage/nyuHealth.jpeg';
import CLEVELANDCLINIC from '../../images/homepage/clevelandClinic.png';
import UCLAHEALTH from '../../images/homepage/uclaHealth.png';
import HCAHEALTH from '../../images/homepage/hcaHealth.png';
import PROVIDENCEHEALTH from '../../images/homepage/providenceHealth.png';
import KAISER2 from '../../images/homepage/kaiserHealth2.png';
import UPMCHEALTH from '../../images/homepage/upmcHealth.png';
import CVSHEALTH from '../../images/homepage/cvsHealth.png';
import UNITEDHEALTHGROUP from '../../images/homepage/unitedHealth.png';
import PFIZER from '../../images/homepage/pfizer.svg.png';
import WALGREENS from '../../images/homepage/walgreens.png';
import AMEDISYS from '../../images/homepage/amedisys.png';
import PROVIDENCE from '../../images/homepage/providence.png';
import NHS from '../../images/homepage/nationalHealthService.png';
import WALMART from '../../images/homepage/walmart.png';
import JNJ from '../../images/homepage/jnj.png';

import NoraHomepage from '../../images/homepage/nora-homepage.png';

import NoraFeatures1 from '../../images/homepage/norafeatures1.png';
import NoraFeatures2 from '../../images/homepage/norafeatures2.png';
import NoraFeatures3 from '../../images/homepage/norafeatures3.png';
import NoraFeatures4 from '../../images/homepage/norafeatures4.png';

import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useMediaQuery } from '@mui/material';

import Review16 from "../../images/homepage/review16.png";
import Review17 from "../../images/homepage/review17.png";
import Review18 from "../../images/homepage/review18.png";
import Review19 from "../../images/homepage/review19.png";
import Review20 from "../../images/homepage/review20.png";
import Review21 from "../../images/homepage/review21.png";

import Container from "../../images/homepage/container.png";
import ContainerMobile from "../../images/homepage/containerMobile.png";

import CompanyCards from '../../components/CompanyCards2';
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

SwiperCore.use([Pagination]);

function NursingHomeScreen({ loginState }) {
    let navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    const [loading, setLoading] = useState(false);
    const { referrerId, name } = useParams();

    useEffect(() => {
        if (referrerId) {
            localStorage.setItem("referredBy", referrerId);
        }
    }, [referrerId]);

    const [openIndex, setOpenIndex] = useState(null);
    const faqRefs = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        const isMobile = window.innerWidth <= 600;
        faqRefs.current.forEach((ref, idx) => {
            if (ref) {
                if (openIndex === idx) {
                    const contentHeight = ref.scrollHeight;
                    ref.style.maxHeight = `${contentHeight}px`;
                    
                    if (isMobile) {
                        const basePadding = 165;
                        const extraPadding = Math.min(contentHeight * 0.1, 100);
                        const totalPadding = basePadding + extraPadding;
                        ref.style.padding = `0 20px ${totalPadding}px`;
                    } else {
                        ref.style.padding = '0 20px 70px';
                    }
                } else {
                    ref.style.maxHeight = '0';
                    ref.style.padding = '0 20px';
                }
            }
        });
    }, [openIndex]);
    
    const faqs = [
        {
            question: "Can Nora help me improve specific skills, like communication or technical knowledge?",
            answer: "Yes! Nora's got you covered. Whether it's technical know-how, communication skills, or overall interview performance, Nora gives you feedback on where you can improve and offers tips to help you level up."
        },
        {
            question: "Does Nora have questions specific to nursing and CNA interviews?",
            answer: "Yes! Nora has interview questions tailored to nursing roles including CNA, new grad RN, and experienced nurse positions. The questions cover behavioral scenarios, patient care situations, and the kind of questions hospitals actually ask"
        },
        {
            question: "Does Nora handle non-native speakers or users with accents?",
            answer: "Nora is designed to understand a variety of accents and speech patterns - you'll have an awesome experience regardless :)"
        },
        {
            question: "Can I track my progress and compare different interview sessions?",
            answer: "Yep, you sure can! Nora lets you look back at each mock interview, track your progress, and compare how you've done over time. It's a great way to see what's improving and what might still need some work."
        },
        {
            question: "I'm a new grad nurse with no real interview experience. Is Nora still useful?",
            answer: "That's exactly who Nora is built for. You don't need prior interview experience — just show up, answer the questions out loud, and Nora will tell you precisely what's working and what needs work"
        },
        {
            question: "How much does Nora cost?",
            answer: "First mock interview & feedback is free. After that, it's $15/month for unlimited mock interviews and feedback!"
        }
    ];

    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const toggleVisibility = () => {
            const scrolled = document.documentElement.scrollTop;
            const maxHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercentage = (scrolled / maxHeight) * 100;
        
            if (scrolled > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            setScrollProgress(scrollPercentage);
        };
    
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
        <Helmet>
            <title>Nursing Interview Prep & Practice Questions | Nora AI</title>
            <meta name="description" content="Practice nursing interviews with Nora AI. Real RN and CNA behavioral questions, AI mock interviews, and instant feedback to help you ace your hospital interview." />
            <meta name="keywords" content="nursing interview prep, CNA interview practice, RN interview questions, AI mock interview for nurses, behavioral interview nursing, new grad RN interview, hospital interview preparation" />
            <link rel="canonical" href="https://interview.norahq.com/nursing" />

            {/* Open Graph */}
            <meta property="og:title" content="Nursing Interview Prep & Practice Questions | Nora AI" />
            <meta property="og:description" content="Practice nursing interviews with Nora AI. Real RN and CNA behavioral questions, AI mock interviews, and instant feedback to help you ace your hospital interview." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://interview.norahq.com/nursing" />
            <meta property="og:image" content="https://interview.norahq.com/images/logo/nora-ai-logo.png" />

            {/* Organization Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Nora AI",
                "url": "https://interview.norahq.com/nursing",
                "logo": "https://interview.norahq.com/images/logo/nora-ai-logo.png",
                "description": "AI mock interviewer helping nurses and CNAs prepare for hospital interviews with real behavioral questions and personalized feedback",
                "sameAs": [
                "https://www.linkedin.com/company/norahq",
                "https://www.instagram.com/trynorahq/",
                "https://www.tiktok.com/@norahq"
                ]
            })}</script>

            {/* Website Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Nora AI",
                "url": "https://interview.norahq.com/nursing",
                "description": "AI mock interviewer helping nurses and CNAs prepare for hospital interviews with real behavioral questions and personalized feedback",
                "potentialAction": {
                "@type": "SearchAction",
                "target": "https://interview.norahq.com/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
                }
            })}</script>

            {/* SoftwareApplication Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "SoftwareApplication",
                "name": "Nora AI",
                "description": "AI-powered interview preparation platform for nurses and CNAs with real hospital questions and personalized feedback",
                "url": "https://interview.norahq.com/nursing",
                "applicationCategory": "Educational Software",
                "operatingSystem": "Web Browser",
                "offers": {
                "@type": "Offer",
                "price": "15",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
                }
            })}</script>

            {/* Service Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Service",
                "name": "Nora AI Mock Interviewer for Nurses",
                "description": "AI mock interview platform for nurses and CNAs. Practice real hospital behavioral questions and get personalized feedback after every session.",
                "provider": {
                "@type": "Organization",
                "name": "Nora AI"
                },
                "serviceType": "Nursing Interview Preparation",
                "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "price": "0",
                "priceCurrency": "USD"
                }
            })}</script>
        </Helmet>
        <div className='homepage'>
            {loading && (
                <div className="loader3">
                    <div className="loader2"></div>
                </div>
            )}

            {/* ── HERO SECTION ── */}
            <div className={isMobile ? "landing landing-mobile" : "landing"}>
                <div className="left-container">
                    <div className="badge-pill">
                        <span className="badge-plus">+</span> The #1 AI Mock Interviewer
                    </div>

                    <h1>
                        {name ? (
                            <>
                            {decodeURIComponent(name).replace(/^\w/, c => c.toUpperCase())}, invited you to Nora AI.
                            <br />
                            Get 25% off our paid plan 😀
                            </>
                        ) : (
                            <>
                            Practice Interviews
                            <br />
                            for 
                            <span className="rotating-role" style={{ color: '#7D994D' }}> Nursing </span>
                            </>
                        )}
                    </h1>

                    <p>
                        Interview coming up? Sharpen your skills with AI-powered interview sessions and feedback actually built for the nursing world.
                    </p>

                    {!loginState.loggedIn && (
                        <button
                            className="nora-landing-cta"
                            onClick={() => name
                                ? navigate("/login", {
                                    state: {
                                        referredFrom: referrerId || null,
                                        userReferred: true
                                    }
                                })
                                : navigate("/login")
                            }
                        >
                            {name ? "Accept Invitation" : "Practice with Nora Mock Interviewer"} &nbsp;→
                        </button>
                    )}

                    <div className="social-proof">
                        <div className="social-proof-row">
                            <div className="avatar-group">
                                <img src={Review16} alt="user" className="avatar-img" />
                                <img src={Review17} alt="user" className="avatar-img" />
                                <img src={Review18} alt="user" className="avatar-img" />
                                <img src={Review20} alt="user" className="avatar-img" />
                            </div>
                            <span className="social-proof-text">
                                Join <strong>10,800+</strong> candidates practicing
                            </span>
                        </div>
                        <a href="https://www.norahq.com" className="social-proof-link">
                            Hiring team? See AI Screening
                        </a>
                    </div>
                </div>

                {!isMobile && (
                    <div className="right-container">
                        <img
                            src={NoraHomepage}
                            alt="Nora AI Mock Interviewer in action"
                            className="hero-image"
                        />
                    </div>
                )}
            </div>

            {/* Mobile-only hero image */}
            {isMobile && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 16px 0' }}>
                    <img
                        src={NoraHomepage}
                        alt="Nora AI Mock Interviewer in action"
                        style={{ maxWidth: '95%' }}
                    />
                </div>
            )}

            {/* Logo slider */}
            <div className="logo-slider">
                {/* <h2 className="companies-header">Companies Our Users Have Received Offers From</h2> */}
                <p className="companies-header">
                    Companies Our Users Have Received Offers From
                </p>
                <div className="logo-track">
                    {[...Array(2)].map(() => (
                        <>
                            <div className="logo-item">
                                <img src={MAYOCLINIC} alt="Mayo Clinic" />
                            </div>
                            <div className="logo-item">
                                <img src={KAISER} alt="kaiser" />
                            </div>
                            <div className="logo-item">
                                <img src={NYUHEALTH} alt="NYU Health" />
                            </div>
                            <div className="logo-item">
                                <img src={CLEVELANDCLINIC} alt="Cleveland Clinic" />
                            </div>
                            <div className="logo-item">
                                <img src={UCLAHEALTH} alt="UCLA Health" />
                            </div>
                            <div className="logo-item">
                                <img src={HCAHEALTH} alt="HCA Health" />
                            </div>
                            <div className="logo-item">
                                <img src={PROVIDENCEHEALTH} alt="Providence Health" />
                            </div>
                            <div className="logo-item">
                                <img src={KAISER2} alt="Kaiser 2" />
                            </div>
                            <div className="logo-item">
                                <img src={UPMCHEALTH} alt="UPMC Health" />
                            </div>
                            <div className="logo-item">
                                <img src={JNJ} alt="Johnsons & Johnson" />
                            </div>
                            <div className="logo-item">
                                <img src={CVSHEALTH} alt="CVS Health" />
                            </div>
                            <div className="logo-item">
                                <img src={UNITEDHEALTHGROUP} alt="United Health Group" />
                            </div>
                            <div className="logo-item">
                                <img src={PFIZER} alt="Pfizer" />
                            </div>
                            <div className="logo-item">
                                <img src={AMEDISYS} alt="Amedisys" />
                            </div>
                            <div className="logo-item">
                                <img src={WALGREENS} alt="Walgreens" />
                            </div>
                            <div className="logo-item">
                                <img src={PROVIDENCE} alt="Providence" />
                            </div>
                            <div className="logo-item">
                                <img src={NHS} alt="NHS" />
                            </div>
                            <div className="logo-item">
                                <img src={WALMART} alt="Walmart" />
                            </div>
                        </>
                    ))}
                </div>
            </div>

            <div className="outsourcing-solution" id="how-it-works">
                <h2 className="outsourcing-heading">How Nora Works - <span style={{ color: '#7D994D' }}> It's Simple. </span> </h2>
                <p className="outsourcing-description">
                    3 simple steps to level up your interview game
                </p>
            </div>

            <div className="how-it-works-1-partnership">
                <img src={isMobile ? ContainerMobile : Container} alt="Feedback" id="feedback-picture" className='image2-styling' />
            </div>

            <div className="outsourcing-solution">
                <h2 className="outsourcing-heading">Watch Nora in Real Time</h2>
                <p className="outsourcing-description" style={{ marginBottom: '50px' }}>
                    Watch how Nora works in real life, and can offer valuable interview practice.
                </p>
                <iframe
                    width={isMobile ? "380" : "640"}
                    height={isMobile ? "214" : "360"}
                    src="https://www.youtube.com/embed/7u0Rf3D_jN0?si=wlmJwsxo5_QjGrrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>

            <div className="outsourcing-solution" id="how-it-works" style={{ marginTop: isMobile ? '30%' : '7%' }}>
                <h2 className="outsourcing-heading">The last <span style={{ color: '#7D994D' }}> Mock Interview </span> you'll ever need </h2>
                <p className="outsourcing-description">
                    Real company questions, a mock interview that actually feels like the real thing, and feedback that doesn't sugarcoat
                </p>
            </div>

            <div className="features-grid-section">
                <div className="features-grid">
                    <div className="feature-card">
                        <img src={NoraFeatures1} alt="Real Interview Questions" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Real Questions from the Real World</h3>
                            <p>We simulate reality by sourcing the latest questions from across the internet and our vetted database.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures2} alt="AI Feedback" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Extremely Realistic Voice Interaction</h3>
                            <p>"Everything is answered through voice... it really feels like you're interviewing with the recruiter."</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures3} alt="Any Role" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>No Cap, Here's How You Did</h3>
                            <p>See your mock interview score, your skills gaps, and chat with Nora to level up fast.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures4} alt="Track Progress" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Tailored Modes for Every Need</h3>
                            <p>Choose the specific type of interview practice you need today.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cool-homepage-section">
                <h2 className="outsourcing-heading">"This feels like having the interview questions a day before."</h2>
                {!loginState.loggedIn && (
                    <div className="button-container">
                        <button className="nora-button-style"
                            style={{ marginTop: '10px' }}
                            onClick={() => name
                                ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                                : navigate("/login")
                            }>
                            And the interview answers.
                        </button>
                    </div>
                )}
            </div>

            <div className="cta-container" id="testimonials">
                <div className="cta-text">Hear from Applicants like you</div>
            </div>
            <div>
                <Swiper
                    spaceBetween={0}
                    slidesPerView={isMobile ? 1 : 3}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    style={{ margin: 'auto', paddingBottom: '70px', paddingTop: '20px' }}
                >
                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review16}
                                    alt="Crystal Ton Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Crystal T.</h3>
                                <p className="title">New Grad RN, UC Health</p>
                                <p className="quote">
                                    "I had my panel interview in 3 days and had no idea what to expect. 
                                    Nora ran me through real behavioral and situation questions that were similar to my actual interview!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review17}
                                    alt="Tey Jon Paul Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Tey Jon P.</h3>
                                <p className="title">Registered Nurse, Providence</p>
                                <p className="quote">
                                    "I've always been good at the clinical stuff but the interview part terrified me. 
                                    Practicing with Nora made it feel like just another skill I could actually get better at"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review18}
                                    alt="Lauren Han Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Lauren H.</h3>
                                <p className="title">Outpatient Nurse</p>
                                <p className="quote">
                                    "Easily the best way to prepare for an interview.
                                    With constructive, personalized feedback, I'd recommend Nora to anybody looking to
                                    prepare for any upcoming interviews. Such a great resource!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review19}
                                    alt="Taina Arry Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Taina A.</h3>
                                <p className="title">Nursing Student, MaineHealth</p>
                                <p className="quote">
                                    "Nora is a lifesaver! I ran out of interview prep options and didn't know what to do!
                                    Nora actually knew what a charge nurse would ask a new CNA - literally asked me two of the same questions Nora did"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review20}
                                    alt="Mikaila Bramlette Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Mikaila B.</h3>
                                <p className="title">New Grad RN, Ascension</p>
                                <p className="quote">
                                    "The questions felt so real. 
                                    Not generic stuff you find on Google, actual scenarios a hiring manager would throw at you"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review21}
                                    alt="Destiny W Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Destiny W.</h3>
                                <p className="title">NICU Nurse, Cedars-Sinai</p>
                                <p className="quote">
                                    "First nursing interview in 4 years, I forgot how nerve-wracking this is! 
                                    Nora got me back in shape real fast"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>

            </div>

            {/* FAQ Section */}
            <div className="faq-section" id="faqs">
                <h2 style={{
                    fontSize: '32px',
                    marginBottom: '25px',
                    fontWeight: '500',
                    fontFamily: "'Lateef', serif",
                    textAlign: 'center'
                }}> Frequently <span style={{ color: '#7D994D' }}> Asked Questions </span> </h2>
                {faqs.map((faq, index) => (
                    <div className="faq-item" key={index}>
                        <button
                            className="faq-question"
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}
                            <span className="arrow">{openIndex === index ? '▼' : '▲'}</span>
                        </button>
                        <div
                            className="faq-answer"
                            ref={el => faqRefs.current[index] = el}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>

            {/* Company Mock Interview Section */}
            <div>
                <h2 className="company-mock-section-section">Jump start your interview practice now.</h2>
                <CompanyCards />
            </div>

            <div className={isMobile ? "practiceNoraCard-mobile" : "practiceNoraCard"}>
                <div style={{ textAlign: "center" }}>
                    <div className={isMobile ? "practiceNoraCardHead-mobile" : "practiceNoraCardHead"}>Ready to begin mastering interviews with Nora?</div>

                    <button className="nora-button-style"
                        onClick={() => name
                            ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                            : navigate("/login")
                        }>
                        Practice Now
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    </>
    )
}

export default NursingHomeScreen;